<template>
  <div>
  <facit-header></facit-header>
    <div class="profile-div col-sm-6">
      <h5 class="mt-3 mb-3"> Hardware Calculator </h5><br><br>
      <b-form @submit.prevent="calculator('formRegistration')"
              class="ml-4 mr-4 mb-4"
              data-vv-scope="formRegistration">
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">Overhead People Counter Licenses Required</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="pcOverHead"
                        name="pcOverHead"
                        type="number"
                        min=0
                        v-model="pcOverHead">
            </b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">Prespective People Counter Licenses Required</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="pcPrespective"
                        name="pcPrespective"
                        type="number"
                        min=0
                        v-model="pcPrespective">
            </b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">Heatmap Licenses Required</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="heatmap"
                        name="heatmap"
                        type="number"
                        min=0
                        v-model="heatmap">
            </b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">Queue Mananger Licenses Required</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="queueManager"
                        name="queueManager"
                        type="number"
                        min=0
                        v-model="queueManager">
            </b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
        <b-button
          type="submit"
          class="w-100"
          variant="warning">Submit</b-button>
      </b-form><br>
      <h6 class="mt-3 mb-3" v-if="modalShow"> Calculus client hardware requirement </h6>
      <b-table  striped hover
                :fields="fields"
                v-if="modalShow"
                :items="hardwareOptions">
        <template slot="link" slot-scope="data">
          <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
        </template>
      </b-table>
      <h6 class="mt-3 mb-3" v-if="modalShow"> Calculus server hardware requirement (optional) </h6>
      <b-table  striped hover
                :fields="serverFields"
                v-if="modalShow"
                :items="hardwareServerOptions">
        <template slot="link" slot-scope="data">
          <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import API from '@/api';
import Session from '@/Session';
import FacitHeader from '@/components/header';
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'hardware',
  components: { FacitHeader},
  data() {
    return {
      pcOverHead: 0,
      pcPrespective: 0,
      heatmap: 0,
      queueManager: 0,
      modalShow: false,
      totalResult: 0,
      multiple: "x",
      hardwareOptions: [],
      hardwareServerOptions: [],
      specs: "Intel Core i7 8GB RAM 250GB SSD Windows 10 Pro",
      serverSpecs: 'Intel Core i7 8GB RAM 2TB SSD Windows 10 Pro',
      mul: 'x',
      hardware: '1',
      fields: [
        {
          key: 'totalResult',
          label: 'Name',
          thStyle: {
            display: 'none'
          },
        },
        {
          key: 'multiple',
          label: 'Version',
          thStyle: {
            display: 'none'
          },
        },
        {
          key: 'specs',
          label: 'Downloads',
          thStyle: {
            display: 'none'
          },
        },
      ],
      serverFields: [
        {
          key: 'hardware',
          label: 'Name',
          thStyle: {
            display: 'none'
          },
        },
        {
          key: 'mul',
          label: 'Version',
          thStyle: {
            display: 'none'
          },
        },
        {
          key: 'serverSpecs',
          label: 'Downloads',
          thStyle: {
            display: 'none'
          },
        },
      ],
      hardwareObj: { totalResult: '', multiple: '', specs: '' },
      hardwareServerObj: { hardware: '', mul: '', serverSpecs: '' },
    };
  },
  methods: {
    async calculator(scope) {
      try {

          let pcOverHead = parseInt(this.pcOverHead)
          let pcPrespective = parseInt(this.pcPrespective)
          let heatmap = parseInt(this.heatmap)
          let queueManager = parseInt(this.queueManager)
          let total = 0
          this.hardwareOptions = []
          this.hardwareServerOptions = []

          pcOverHead = pcOverHead * 3

          total = Math.ceil((pcOverHead + pcPrespective + heatmap + queueManager) / 18 )

          this.totalResult = total

          this.hardwareObj.totalResult = this.totalResult
          this.hardwareObj.multiple = this.multiple
          this.hardwareObj.specs = this.specs

          this.hardwareServerObj.hardware = this.hardware
          this.hardwareServerObj.mul = this.mul
          this.hardwareServerObj.serverSpecs = this.serverSpecs

          this.hardwareOptions.push(this.hardwareObj)
          this.hardwareServerOptions.push(this.hardwareServerObj)
console.log(this.hardwareServerOptions, this.hardwareOptions);
          if (total > 0) {
            this.modalShow = true
          }

      } catch (error) {

      }
    },
    async onVerify(response) {
      if (response) {
        this.disabledButton = false;
      }
    },
    onExpired() {

    },
    redirect() {
      this.$router.push('/');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.help.is-danger {
    color: #ff3860;
}
.help {
    display: block;
    font-size: 11px;
    margin-top: 5px;
}
span {
    font-style: inherit;
    font-weight: inherit;
}
*, :after, :before {
    box-sizing: inherit;
}
table > thead {
    display:none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/hardwareCalculator.vue